document.addEventListener("DOMContentLoaded", () => {

    const popupMaker = document.querySelectorAll('body .pum-container.popmake');
    if (!popupMaker) return;

    popupMaker.forEach(popupMakerElement => {
        const tabindexElements = popupMakerElement.querySelectorAll('[tabindex="0"]');
        tabindexElements.forEach(element => element.removeAttribute('tabindex'));
    });
});